import React from 'react'
import Slider  from 'react-slick'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right'


const OutreachSlider = ({ media, selectedIndex }) => {
  const firstSlide = (!selectedIndex || selectedIndex === 0)
  const lastSlide = (selectedIndex === media.length - 1 || media.length === 1)

  const sliderSettings = {
    accessibility: true,
    autoplay: false,
    dots: true,
    focusOnSelect: true,
    infinite: false,
    initialSlide: 0,
    nextArrow: lastSlide ? null : <ChevronRight />,
    prevArrow:  firstSlide ? null : <ChevronLeft />,
    slickGoTo: selectedIndex >= 0 ? selectedIndex : 0,
    slidesToShow: 1,
    slidesToscroll: 1,
    swipeToSlide: true,
    useCSS: true
  }


  return (
    <Slider {...sliderSettings}>{media}</Slider>
  );
};

export default OutreachSlider



// WEBPACK FOOTER //
// ./src/components/Outreach/OutreachSlider.js